/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import ConfirmationCrate from '@piwikpro/confirmation-crate';
import TitleCrate from '@piwikpro/title-crate';
import RouterCrate from '@piwikpro/router-crate';
import CookieInformationCrate from '@piwikpro/cookie-information-crate';
import OrganizationCrate from '@piwikpro/organization-crate';
import TrackerSettingsCrate from '@piwikpro/tracker-settings-crate';
import { ContainerSettingsCrate } from '@piwikpro/container-settings-crate/ContainerSettingsCrate';
import { Apps } from './Apps';
import SecuredApps from './components/SecuredApps';
import AppCreator from './components/AppCreator/AppCreator';
import apps from './reducer';
import FirstAppTrial from './components/FirstAppTrial/FirstAppTrial';

@Crate({
  name: 'AppsCrate',
  imports: [
    HttpCrate,
    NotificationCrate,
    ConfirmationCrate,
    RouterCrate,
    TitleCrate,
    TrackerSettingsCrate,
    CookieInformationCrate,
    OrganizationCrate,
    ContainerSettingsCrate,
  ],
  services: [
    { name: 'apps', provide: Apps },
  ],
  components: [
    { name: 'SecuredApps', provide: SecuredApps },
    { name: 'AppCreator', provide: AppCreator },
    { name: 'FirstAppTrial', provide: FirstAppTrial },
  ],
  reducers: {
    apps,
  },
})
export class AppsCrate {}
